import React from "react";
import { RadioGroup } from "@headlessui/react";
import TransactionsList from "components/CompanyDashboard/TransactionsList";
import { useContext } from "react";
import { ManageModuleContext } from "context/ManageCompanyModuleContext";
import BreadCrumb from "components/lib/Global/BreadCrumb";

const Corrections = () => {
  const { handleBackToManageYourCompanyDashboard } =
    useContext(ManageModuleContext);

  const pages = [
    { name: "Home", href: "#", current: false },
    {
      name: "Maintain a company",
      current: false,
      href: "#",
      handleClick: handleBackToManageYourCompanyDashboard,
    },
    {
      name: "Corrections",
      current: true,
      href: null,
      handleClick: false,
    },
  ];
  return (
    <div className="text-sflPrimary">
      <RadioGroup className="my-4">
        <RadioGroup.Label className="text-base">
          <div>
            <div className="bg-white container mx-auto px-4 mb-8">
              <div className="">
                <BreadCrumb pages={pages} />
              </div>
            </div>
            <h2 className="pb-4 font-semibold text-title5">
              Correction Application
            </h2>
            <h1 className="font-medium">
              Initiate transaction of existing business operations or ownership
              to Simple Formation Limited
            </h1>
          </div>
        </RadioGroup.Label>
      </RadioGroup>
      <TransactionsList callFrom={"correction"} />
    </div>
  );
};

export default Corrections;
